module.exports = __webpack_public_path__ + "img/17.024d4a22.png";